var map = {
	"./belfix-at.de.json": "c059",
	"./belfix-be.en.json": "79ca",
	"./belfix-be.fr.json": "9826",
	"./belfix-be.nl.json": "bee7",
	"./belfix-ch.de.json": "b694",
	"./belfix-ch.fr.json": "cd77",
	"./belfix-co-uk.en.json": "7b7b",
	"./belfix-com-es.en.json": "88a1",
	"./belfix-com-es.es.json": "5ff8",
	"./belfix-de.de.json": "6aa0",
	"./belfix-de.en.json": "07ec",
	"./belfix-dk.da.json": "8f00",
	"./belfix-dk.en.json": "d8c0",
	"./belfix-fr.en.json": "2743",
	"./belfix-fr.fr.json": "dc2c",
	"./belfix-gr.el.json": "987e",
	"./belfix-ie.en.json": "f539",
	"./belfix-it.it.json": "fd36",
	"./belfix-lu.de.json": "ef35",
	"./belfix-lu.en.json": "5c4b",
	"./belfix-lu.fr.json": "237a",
	"./belfix-lu.lb.json": "c4f8",
	"./belfix-nl.nl.json": "8b50",
	"./belfix-no.nb.json": "7e51",
	"./belfix-pl.pl.json": "5a53",
	"./belfix-pt.pt.json": "9493",
	"./belfix-se.sv.json": "52a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "30cd";